import { SegmentedControl } from 'blaze-ui/SegmentedControl/SegmentedControl'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Item } from '@react-stately/collections'

interface Props {
  setFileTypeFilter: (type: string) => void
  activeFilter?: string
}

export const FileTypeFilter = ({ setFileTypeFilter, activeFilter }: Props) => {
  const { isMobileMd } = useResponsiveDesign()

  return (
    <SegmentedControl
      activeItem={activeFilter || 'all'}
      onItemClick={(item) => {
        setFileTypeFilter(item as string)
      }}
      isFullWidth={isMobileMd}
    >
      <Item key="all">All Files</Item>
      <Item key="article">Documents</Item>
      <Item key="project">Projects</Item>
    </SegmentedControl>
  )
}
